import $ from 'jquery';

$(window).on('load', function() {

    $('.hamburger').on('click', function() {
        $('html').addClass('scroll-none');
        $('.nav-main').addClass('open');
    });

    $('.nav-main .close-btn').on('click', function() {
        $('html').removeClass('scroll-none');
        $('.nav-main').removeClass('open');
    });

    $('.nav-main .part-1').on('click', function() {
        $(this).addClass('active');
        $('.nav-main .part-2').removeClass('active');
        $('.nav-main .nav-content .part-1').css('display', 'block');
        $('.nav-main .nav-content .part-2').css('display', 'none');
    });

    $('.nav-main .part-2').on('click', function() {
        $(this).addClass('active');
        $('.nav-main .part-1').removeClass('active');
        $('.nav-main .nav-content .part-2').css('display', 'block');
        $('.nav-main .nav-content .part-1').css('display', 'none');
    });

    $('li.menu-item-has-children').on('click', function(e) {
        e.stopPropagation();
        $(this).find('> .submenu').addClass('open');
        $(this).find('> .submenu').find('.title').html($(this).find('a').html());
    });

    $('li.menu-item-has-children .submenu .back-btn').on('click', function(e) {
        e.stopPropagation();
        $(this).closest('.submenu').removeClass('open');
    });

    $('li.menu-item-has-children .submenu li.menu-item-has-children .back-btn').on('click', function(e) {
        e.stopPropagation();
        $(this).closest('.submenu').removeClass('open');
    });

});